import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa, Pagination, PagingResponseModel } from '../shared';
import { TenantRoleContainerModel } from '../../../../../models/aggregates/role';


// core2/platform/dm/iam/roles/

@Injectable({ providedIn: 'root' })
export class PermsetRoleService extends BaseApiTemplateService<TenantRoleContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX +
      Core2Config.IAM_PREFIX +
      'roles';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + 'roles';
    this.httpClient = http;
  }

  // core2/platform/dm/iam/roles/{permSetHdrGuid}/custom-from-link/{tenantCode}/tenant-admin-ep/query
  getByCritreriaUsingPermset(tenantCode: string, permGuid:string, pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<TenantRoleContainerModel>> {
    const queryParams = pagination.getQueryKeyValues();
    let url = `${this.apiUrl}/${permGuid}/custom-from-link/${tenantCode}/tenant-admin-ep/query?${queryParams}`;
    if (this.endpoint_path && visa.api_domain_url) {
      url = `${visa.api_domain_url}${this.endpoint_path}/${permGuid}/custom-from-link/${tenantCode}/tenant-admin-ep/query?${queryParams}`;
    }
    return this.httpClient.get<PagingResponseModel<TenantRoleContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

}
